import React from "react";
import "./Hero.css";

const Hero = ({ children, className = "", compact = false }) => {
  return (
    <section className={`site-hero ${compact ? "site-hero--compact" : ""} ${className}`.trim()}>
      <div className="site-hero__inner">{children}</div>
    </section>
  );
};

export default Hero;
